import { defineComponent as d, openBlock as n, createBlock as l, unref as i, withCtx as o, renderSlot as m } from "vue";
import s from "./ghl-ui.es170.js";
const c = d({
  name: "UICollapse",
  inheritAttrs: !1
}), f = d({
  ...c,
  props: {
    accordion: {
      type: Boolean,
      default: !1
    },
    arrowPlacement: {
      type: String,
      default: "left"
    },
    defaultExpandedNames: {
      type: [String, Number, Array],
      default: void 0
    },
    displayDirective: {
      type: String,
      default: "if"
    },
    expandedNames: {
      type: [String, Number, Array],
      default: void 0
    }
  },
  emits: ["itemHeaderClick"],
  setup(e) {
    return (a, t) => (n(), l(i(s), {
      accordion: e.accordion,
      "arrow-placement": e.arrowPlacement,
      "default-expanded-names": e.defaultExpandedNames,
      onItemHeaderClick: t[0] || (t[0] = (r) => a.$emit("itemHeaderClick", r)),
      "display-directive": e.displayDirective,
      "expanded-names": e.expandedNames
    }, {
      default: o(() => [
        m(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["accordion", "arrow-placement", "default-expanded-names", "display-directive", "expanded-names"]));
  }
}), y = f;
export {
  y as default
};
